module.exports = __webpack_public_path__ + "static/media/Price 2.e542bd31.svg";